import { Builder } from '@builder.io/react';
import image from '@/assets/images/cms/icon.svg?inline';

export interface IconComponentProps<TIconName, TIconSize> {
	readonly icon: TIconName;
	readonly size: TIconSize;
}

const register = <
	TProps extends IconComponentProps<TIconNames[number], TIconSizes[number]>,
	TIconNames extends readonly string[],
	TIconSizes extends readonly string[],
>(
	Component: React.FC<TProps>,
	options: {
		readonly iconNames: TIconNames;
		readonly iconSizes: TIconSizes;
		readonly defaultIconName?: TIconNames[number];
		readonly defaultIconSize?: TIconSizes[number];
	},
): void => {
	Builder.registerComponent(Component, {
		name: 'Icon',
		image,
		inputs: [
			{
				type: 'string',
				name: 'icon',
				required: true,
				enum: Array.from(options.iconNames),
				defaultValue: options.defaultIconName,
			},
			{
				type: 'string',
				name: 'size',
				enum: Array.from(options.iconSizes),
				defaultValue: options.defaultIconSize,
			},
		],
	});
};

export default register;
